module.exports = __webpack_public_path__ + "img/20200227162407430.4d3ddcaa.jpg";